<template>
<div class="customerWrapper">
  <el-row  >
    <b style="font-size:20px">
      {{$t('other.a998')}}
    </b>
  </el-row>
  <el-row class="top">
    <span>{{$t('other.a776')}}:</span>
    <el-radio-group v-model="chooseOption.country" class="select">
      <el-radio-button :label="$t('other.a358')"></el-radio-button>
      <el-radio-button :label="$t('other.a1091')"></el-radio-button>
      <el-radio-button :label="$t('other.a1092')"></el-radio-button>
    </el-radio-group>
  </el-row>

  <el-row class="top">
    <span>{{$t('other.a595')}}:</span>
    <el-radio-group v-model="chooseOption.Platform_type" class="select">
      <el-radio-button :label="$t('other.a358')"></el-radio-button>
      <el-radio-button label="SHOPEE"></el-radio-button>
      <el-radio-button label="LAZADA"></el-radio-button>
      <el-radio-button :label="$t('other.a1004')"></el-radio-button>
    </el-radio-group>
  </el-row>
  <el-row class="top">
    <span>{{$t('other.a359')}}:</span>
    <el-radio-group v-model="chooseOption.shop" class="select">
      <el-radio-button :label="$t('other.a358')"></el-radio-button>
      <el-radio-button v-for="item,index in shopList" :label="item.shopName+'('+translation[item.country]+')'"></el-radio-button>
    </el-radio-group>
    <el-checkbox v-model="ifShopChecked" style="font-size:10px;margin-left:1rem">{{$t('other.a388')}}</el-checkbox>
  </el-row>

  <el-row class="top">
    <span>{{$t('other.a64')}}:</span>
    <el-radio-group v-model="chooseOption.sort" class="select">
      <el-radio-button :label="$t('other.a766')"></el-radio-button>
      <el-radio-button :label="$t('other.a767')"></el-radio-button>
      <el-radio-button :label="$t('other.a768')"></el-radio-button>
      <el-radio-button :label="$t('other.a769')"></el-radio-button>
    </el-radio-group>
  </el-row>
  <el-row class="top">
    <span>{{$t('other.a582')}}:</span>
    <el-input v-model="orderId" :placeholder="$t('other.a574')" style="width:20rem;margin-left:1rem"  ></el-input>
    <el-button @click="queryOrder" type="primary">{{$t('other.a245')}}</el-button>
  </el-row>
  <orderCard v-for="item,index in allOrderList" :orderData="item" ></orderCard>
</div>

  
</template>

<script>

import orderCard from './components/ordercard.vue'
import { mapState } from 'vuex'

export default {
data(){
return{
  orderData:{
    demo:'0000',
    demo2:'1111',
  },
  chooseOption:{
    country:this.$t('other.a358'),
    Platform_type:this.$t('other.a358'),
    shop:this.$t('other.a358'),
    sort:this.$t('other.a766'),
  },
  ifShopChecked:false,
  translation:{
    TH:this.$t('other.a1091'),
    MY:this.$t('other.a1092')
  },
  orderId:'',




}
},

components:{
  orderCard
},

    computed:{
        ...mapState({
            userId: state => state.shopaccess.userInfo.userId,
            lazadashopinfo: state=>state.shopaccess.lazadashopinfo,
			      shopList: state => state.shopaccess.shopInfo || '',
            amountListCount:state=>state.processed.amountListCount ,  
            				allOrderList:state => state.order.allOrder,

        }),
    },

watch:{
  

  

},

created(){

},
mounted(){
   

},
methods:{
  queryOrder(){
    console.log(this.allOrderList)
  },

 
   

}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
.customerWrapper{
  .top{
    margin-top:20px
  }
  .right{
    float: right;
  }
  .left{
    float: left;
  }
  .select{
    margin-left:1rem
  }

  
      

     
     


    
        

    
    

}

</style>